"use client";

import * as React from "react";

import classNames from "classnames";

import { LinkButton } from "@stadium/shared/src/components/shared/button";

import { usePlasmicQueryData } from "@stadium/services/plasmic";

import { fetchPlasmicCMSData } from "@stadium/shared/src/helpers/plasmic/cms-api";

import { BE04_TABLE_ID, CMS_FIELDS, CMS_SECTION_FIELDS } from "./constants";

import BlogCardsBase from "@stadium/shared/src/components/plasmic/BlogEntry/blog-cards-base";

import styles from "./main.module.scss";

export interface BE04Props {
  className?: string;
}

const BE04: React.FC<Readonly<BE04Props>> = ({ className }) => {
  const { data, isLoading } = usePlasmicQueryData([BE04_TABLE_ID], async () => {
    const data = await fetchPlasmicCMSData({ tableId: BE04_TABLE_ID });
    if (!data) return null;

    return {
      heading: data[CMS_SECTION_FIELDS.HEADING] || "",
      seeAllText: data[CMS_SECTION_FIELDS.SEE_ALL_TEXT] || "",
      seeAllUrl: data[CMS_SECTION_FIELDS.SEE_ALL_URL] || "",
      cards: (data[CMS_SECTION_FIELDS.CARD] || []).map((item: any) => ({
        image: item[CMS_FIELDS.IMAGE]?.url,
        imageAlt: item[CMS_FIELDS.TITLE] || "",
        title: item[CMS_FIELDS.TITLE],
        description: item[CMS_FIELDS.DESCRIPTION],
      })),
    };
  });

  if (isLoading) return null;
  if (!data) return null;

  return (
    <section className={classNames(styles.sectionWrapper, className)}>
      <div className={styles.divWrapper}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.titleGroup}>
            <h2 className={styles.title}>{data.heading}</h2>
            <span className={styles.titleArrow}></span>
          </div>
          <LinkButton styleType="no-style" href={data.seeAllUrl} className={styles.seeAllLink}>
            <span className={styles.seeAllText}>{data.seeAllText}</span>
            <span className={styles.arrowUpIcon}></span>
          </LinkButton>
        </div>

        {/* Cards */}
        <BlogCardsBase variant="BE04" cards={data.cards} styles={styles} />
      </div>
    </section>
  );
};

export default BE04;
